import {Component, Input} from '@angular/core';
import {Hold, HOLD_STATUS} from '@raven';

@Component({
  selector: 'rn-hold-status',
  styles: `
      .hide {
          display: none;
      }

      .show {
          display: inline-block;
      }
  `,
  template: `
    @if (hold) {
      <mat-chip-set>
        <!--[ngClass]="hold ? 'show' : 'hide'">-->
        @if (hold.status === HOLD_STATUS.REQUESTED) {
          <mat-chip class="blue-pill"
                    matTooltip="{{ hold.placedDate | date: 'MMM d, y' }}">
            Requested {{ hold.placedDate | date: 'MMM d' }}
          </mat-chip>
        }
        @if (hold.status === HOLD_STATUS.TRANSIT) {
          <mat-chip class="yellow-pill"
                    matTooltip="In Transit as of {{ hold.modifiedDate | date: 'MMM d, y' }}">
            In Transit
          </mat-chip>
        }
        @if (hold.status === HOLD_STATUS.HELD) {
          <mat-chip class="green-pill"
                    matTooltip="Item must be picked up by {{ hold.pickupExpireDate | date: 'MMM d, y'}}">
            Pick up by {{ hold.pickupExpireDate | date: 'MMM d' ?? 'Ready for pick up' }}
          </mat-chip>
        }
        @if (hold.status === HOLD_STATUS.PICKED_UP) {
          <mat-chip class="green-pill">
            Checked Out
          </mat-chip>
        }
        @if (hold.status === HOLD_STATUS.EXPIRED) {
          <mat-chip class="red-pill"
                    matTooltip="{{ hold.expireDate | date: 'MMM d, y' }}">
            Expired on {{ hold.expireDate | date: 'MMM d' }}
          </mat-chip>
        }
        @if (hold.status === HOLD_STATUS.PAUSED && hold.notWantedBefore) {
          <mat-chip class="gray-pill"
                    matTooltip="{{ hold.notWantedBefore | date: 'MMM d, y' }}">
            Paused until {{ hold.notWantedBefore | date: 'MMM d' }}
          </mat-chip>
        }
        @if (hold.status === HOLD_STATUS.PAUSED && !hold.notWantedBefore) {
          <mat-chip class="gray-pill">
            Paused
          </mat-chip>
        }
        @if (hold.status === HOLD_STATUS.CANCELED) {
          <mat-chip class="red-pill"
                    matTooltip="{{ hold.modifiedDate | date: 'MMM d, y' }}">
            Canceled {{ hold.modifiedDate | date: 'MMM d' }}
          </mat-chip>
        }
        @if (hold.status === HOLD_STATUS.PULLED) {
          <mat-chip class="yellow-pill">
            Pulled
          </mat-chip>
        }
        @if (hold.status === HOLD_STATUS.PENDING) {
          <mat-chip class="yellow-pill">
            Pending
          </mat-chip>
        }
        @if (hold.status === HOLD_STATUS.NOT_SUPPLIED) {
          <mat-chip class="red-pill">
            Not Supplied
          </mat-chip>
        }
        @if (hold.status === HOLD_STATUS.UNCLAIMED) {
          <mat-chip class="red-pill">
            Unclaimed
          </mat-chip>
        }
      </mat-chip-set>
    }
  `,
  standalone: false
})
export class HoldStatusComponent {
  HOLD_STATUS = HOLD_STATUS;
  @Input() hold: Hold;
}
